


















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { dictServe, doublePrevention, performanceServer, professionServer, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component
export default class PublicProp extends Vue {
  @Prop(Object) rowId: any;
  private visible = false;
  private title = '';
  private isDisabled = false;
  private formData: any = {
    company: '',
    dangerSourceId: '',
    hazardCategoryTagId: '',
    hazardCategoryTagName: '',
    hazardCode: '',
    hazardControlMeasure: '',
    postIds: [],
    riskControlRunawayShow: '',
    riskDescription: '',
    riskLevel: '',
    riskPointId: '',
    stockRoom: '',
    taskPostId: '',
    teamGroup: '',
    workShop: '',
  };
  private formRules: any = {
    hazardCode: [{ required: true, message: '请填写隐患代码', trigger: 'blur' }],
    hazardCategoryTagId: [{ required: true, message: '请选择隐患分类', trigger: 'blur' }],
    riskLevel: [{ required: true, message: '请选择隐患等级', trigger: 'blur' }],
    riskPointId: [{ required: true, message: '请选择风险点', trigger: 'blur' }],
  };
  private spaceAreaList: any = []; // 区域的下拉
  private riskPointList: any = []; // 风险点的下拉
  private dangerSourceIdList: any = []; // 这个是 选择完风险点才会出现的危险源的下拉（过滤后的数据）
  private riskPointAndDangerData: any = []; // 风险点 、 '危险源' 的数组
  private hazardLevelList: any = [];
  private hazardCategoryTagNameList: any = [];
  private postIdList: any = []; // 岗位列表

  private showDialog() {
    this.getSpaceAreaData(); // 区域列表
    this.getAllPostList(); // 岗位列表
    this.getSecurityCheckHazardLevel(); // 隐患等级的接口
    this.getHazardCategoryTagNameList(); // 隐患分类的接口
    switch (this.rowId.type) {
      case 'add':
        this.title = '添加隐患排查清单';
        break;
      case 'edit':
        this.title = '编辑隐患排查清单';
        this.getRiskControlInventoryHazardDetail();
        break;
      case 'detail':
        this.title = '隐患排查清单详情';
        this.isDisabled = true;
        this.getRiskControlInventoryHazardDetail();
        break;
    }
    this.visible = true;
  }

  private hideDialog() {
    this.visible = false;
    this.spaceAreaList = [];
    this.riskPointList = [];
    this.dangerSourceIdList = [];
    this.riskPointAndDangerData = [];
    this.hazardLevelList = [];
    this.formData = {
      company: '',
      dangerSourceId: '',
      hazardCategoryTagId: '',
      hazardCategoryTagName: '',
      hazardCode: '',
      hazardControlMeasure: '',
      postIds: [],
      riskControlRunawayShow: '',
      riskDescription: '',
      riskLevel: '',
      riskPointId: '',
      stockRoom: '',
      taskPostId: '',
      teamGroup: '',
      workShop: '',
    };
    this.isDisabled = false;
    this.$emit('riskControlInventoryHazardHide');
  }

  private submitForm() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (valid) {
        if (this.rowId.type === 'edit') {
          // 编辑的保存
          this.modifyRiskControlInventoryHazard();
        } else {
          // 新增的保存
          this.addRiskControlInventoryHazard();
        }
      }
    });
  }

  // 详情
  private getRiskControlInventoryHazardDetail() {
    doublePrevention.getRiskControlInventoryHazardDetail(this.rowId.data.id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (res.data.areaId) {
          this.getRiskAndDangerSourceLis(res.data.areaId);
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 编辑
  private modifyRiskControlInventoryHazard() {
    doublePrevention
      .modifyRiskControlInventoryHazard({
        company: this.formData.company,
        dangerSourceId: this.formData.dangerSourceId,
        hazardCategoryTagId: this.formData.hazardCategoryTagId,
        hazardCategoryTagName: this.formData.hazardCategoryTagName,
        hazardCode: this.formData.hazardCode,
        hazardControlMeasure: this.formData.hazardControlMeasure,
        postIds: this.formData.postIds,
        riskControlRunawayShow: this.formData.riskControlRunawayShow,
        riskDescription: this.formData.riskDescription,
        riskLevel: this.formData.riskLevel,
        riskPointId: this.formData.riskPointId,
        stockRoom: this.formData.stockRoom,
        taskPostId: this.formData.taskPostId,
        teamGroup: this.formData.teamGroup,
        workShop: this.formData.workShop,
        id: this.formData.id,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功编辑了该条数据！');
          this.hideDialog();
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  // 新增
  private addRiskControlInventoryHazard() {
    doublePrevention
      .addRiskControlInventoryHazard({
        company: this.formData.company,
        dangerSourceId: this.formData.dangerSourceId,
        hazardCategoryTagId: this.formData.hazardCategoryTagId,
        hazardCategoryTagName: this.formData.hazardCategoryTagName,
        hazardCode: this.formData.hazardCode,
        hazardControlMeasure: this.formData.hazardControlMeasure,
        postIds: this.formData.postIds,
        riskControlRunawayShow: this.formData.riskControlRunawayShow,
        riskDescription: this.formData.riskDescription,
        riskLevel: this.formData.riskLevel,
        riskPointId: this.formData.riskPointId,
        stockRoom: this.formData.stockRoom,
        taskPostId: this.formData.taskPostId,
        teamGroup: this.formData.teamGroup,
        workShop: this.formData.workShop,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功添加了一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  /**
   * @desc 获取隐患等级所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSecurityCheckHazardLevel() {
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('securityCheckHazardLevel')
      .then((res: any) => {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.hazardLevelList = helpArr;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private getHazardCategoryTagNameList() {
    performanceServer
      .getTagManageList({ type: 'hazardClassify' })
      .then((res: any) => {
        res.data.forEach((r: any) => {
          if (!r.children.length) {
            delete r.children;
          }
        });
        this.hazardCategoryTagNameList = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 区域列表
  getSpaceAreaData() {
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    regionServe.getAreaAndSubAreaList({ areaId: userInfo.areaId }).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
        this.formData.areaId = userInfo.areaId;
        if (userInfo.areaId) {
          this.getRiskAndDangerSourceLis(userInfo.areaId);
        }
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }
  hazardCategoryTypeChange(e: any) {
    if (e) {
      this.formData.hazardCategoryTagName = (this.$refs.elCascaderHazardType as any).getCheckedNodes()[0].label;
    } else {
      this.formData.hazardCategoryTagName = '';
    }
  }

  // 获取风险点和未过滤的危险源的下拉
  getRiskData(e: any) {
    this.riskPointList = [];
    this.dangerSourceIdList = [];
    this.riskPointAndDangerData = [];
    this.formData.riskPointId = '';
    this.formData.dangerSourceId = '';
    if (e) {
      this.getRiskAndDangerSourceLis(e);
    }
  }

  // 获取过滤后的危险源的下拉（选择完风险点才有危险源 -> 风险点的id是危险源的pid）
  private getDangerSource(data: any) {
    this.formData.dangerSourceId = '';
    this.dangerSourceIdList = this.riskPointAndDangerData.filter((item: any) => item.type === '危险源' && item.pid === data);
  }

  private getRiskAndDangerSourceLis(areaId: any) {
    doublePrevention
      .getRiskAll({
        areaId: areaId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.riskPointAndDangerData = res.data;
          this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
          if (this.formData.riskPointId) {
            this.dangerSourceIdList = res.data.filter((item: any) => item.type === '危险源' && item.pid === this.formData.riskPointId);
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  public getAllPostList() {
    professionServer
      .getPageDataAll({})
      .then((res: any) => {
        // console.log(res);
        this.postIdList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取岗位的数据失败！');
      });
  }
}
